import { render, staticRenderFns } from "./NewsDetailsTwo.vue?vue&type=template&id=63c5a352&scoped=true"
import script from "./NewsDetailsTwo.vue?vue&type=script&lang=js"
export * from "./NewsDetailsTwo.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailsTwo.vue?vue&type=style&index=0&id=63c5a352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c5a352",
  null
  
)

export default component.exports